module.exports = __webpack_public_path__ + "static/media/Clarisse Misola.98296949.png";